declare global {
	interface Window {
		xsrf_val: string;
	}
}

class ErrorResponse extends Error {
	response: Response;
	data: any;

	constructor(message = "", res = new Response(), data = {}) {
		super(message);
		this.response = res;
		this.data = data;
	}
}

// Build a custom wrapper around fetch
export const request = async <T>(url: string, options: RequestInit = {}): Promise<[T, Response]> => {
	const csrfValue = window.xsrf_val;

	const headers = {
		"X-CSRFToken": csrfValue,
		"Content-Type": "application/json",
		...options.headers,
	};

	const response = await fetch(url, { ...options, headers });

	if (!response.ok) {
		let errorData: unknown = {};
		try {
			errorData = await response.json();
		} catch {
			errorData = {};
		}
		throw new ErrorResponse(
			response.statusText ? response.statusText : "Bad fetch response",
			response,
			errorData as object
		);
	}

	const data = (await response.json()) as T;

	return [data, response];
};

export default request;
